(function () {
  function fold(value) {
    return (value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function valuesFrom(picker) {
    var vals = ['', '', ''];
    picker.querySelectorAll('fieldset').forEach(function (fs) {
      var i = parseInt(fs.getAttribute('data-option-index'), 10);
      var active = fs.querySelector('[data-option-btn].is-active');
      if (!isNaN(i) && active) vals[i] = active.getAttribute('data-value');
    });
    return vals;
  }
  function showImage(src) {
    if (!src) return;
    var img = document.querySelector('[data-gallery-main]');
    if (img) {
      img.src = src;
      img.removeAttribute('srcset');
    }
    var zoom = document.querySelector('[data-zoom-image]');
    if (zoom) zoom.src = src;
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      var full = thumb.getAttribute('data-full-src') || '';
      var on = full && src.indexOf(full.split('?')[0].split('/').pop()) !== -1;
      thumb.classList.toggle('is-active', on);
      thumb.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function imageFor(select, picker) {
    var chosen = select.options[select.selectedIndex];
    var src = chosen && chosen.getAttribute('data-image');
    if (src) return src;
    var color = picker.querySelector('.soniel-picker__opt--color [data-option-btn].is-active');
    var key = fold(color && color.getAttribute('data-value'));
    if (!key) return '';
    var found = '';
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      var blob = fold((thumb.getAttribute('data-alt') || '') + ' ' + (thumb.getAttribute('data-full-src') || ''));
      if (!found && blob.indexOf(key) !== -1) found = thumb.getAttribute('data-full-src');
    });
    return found;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-option-btn]');
    if (!btn) return;
    var picker = btn.closest('[data-soniel-picker]');
    var select = picker && picker.querySelector('[data-product-variant]');
    if (!select) return;
    var field = btn.closest('fieldset');
    if (field) {
      field.querySelectorAll('[data-option-btn]').forEach(function (other) {
        var on = other === btn;
        other.classList.toggle('is-active', on);
        other.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var label = field.querySelector('[data-option-label]');
      if (label) label.textContent = btn.getAttribute('data-value') || '';
    }
    window.setTimeout(function () {
      var values = valuesFrom(picker);
      Array.prototype.forEach.call(select.options, function (opt) {
        var parts = (opt.getAttribute('data-options') || '').split('|||');
        var ok = values.every(function (val, i) { return !val || parts[i] === val; });
        if (ok && !opt.disabled) select.value = opt.value;
      });
      if (btn.closest('.soniel-picker__opt--color')) showImage(imageFor(select, picker));
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }, 0);
  }, true);
})();
